let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("83I2X")).then(() => parcelRequire('7JV09'));